/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

/*global $ */
var app = app || {};
/**
 * Использовать подсказки daData для адресов
 * @type {boolean}
 */
app.hasDaDataSuggest = true;

document.addEventListener('DOMContentLoaded', function initApp () {
  'use strict';

  /**
   * Массив для хранения глобальных компонентов.
   * @type {Array}
   */
  app.registry = [];

  /**
   * в Microsoft пишут что у них всё поддерживается но опыт показывает что нет.
   *
   * @link https://msdn.microsoft.com/ru-ru/library/mt146828(v=vs.94).aspx
   * @link https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Number/isFinite
   */
  Number.isFinite = Number.isFinite || function (value) {
    return typeof value === 'number' && isFinite(value);
  };

  if (!app.isOffice) {
    window.Raven = {
      captureException: function (error) {
        console.error(error.message); // eslint-disable-line
      },
    };
  }


    // создание канала прослушки cqc-команд (пока ничего не слушаем)
    app.helpers.CQCHelper.createExecuteChannel(_.values(app.CQC_COMMAND_TYPES));
    app.helpers.CQCHelper.createCommandChannel(_.values(app.CQC_COMMAND_TYPES));

  // массив для заполнения командами на страницах в switch-case
  var cqcExecuteCommandTypes = [
    app.CQC_COMMAND_TYPES.showAuthForm,
  ],
    layout = $('.layout'),
    jsView = layout.data('jsview') || $('.main-content').data('jsview');

  /**
   * Инициализация модели пользователя.
   */
  app.user = new app.User();
  if (app.userJson) {
    app.user.set(app.userJson);
  }
  if (app.user.get('is_new_user') && app.user.id) {
    app.helpers.OkoHelper.push({
      'n': 'new-user',
      'user-id': parseInt(app.user.id, 10),
    });
  }
  /**
   * Инициализация модели города.
   */
  app.settlement = new app.SettlementForm(null, {
    user: app.user,
    needSave: app.JSVIEWS_SETTLEMENT_MUST_SAVE.indexOf(jsView) !== -1,
  });
  Backbone.trigger('settlement-initialized');
  app.settlement.attachMinSumTrigger();
  app.settlement.set(app.settlementJson);
  app.settlement.currentSettlementId = app.settlement.get('settlement_id');
  /**
   * Инициализация корзины.
   */
  app.cart = new app.Cart(
    null,
    {
      settlement: app.settlement,
      isSavedAnalogStates: app.features.is_saved_analog_states,
      needHeaderUpdate: jsView !== 'reactive-checkout',
    });
  app.helpers.OkoHelper.connectCartToOko(app.cart);

  // глобальная шина событий
  app.EventBus = _.extend({}, Backbone.Events);
  // должно быть везде - реакция рекомендаций на действия пользователя
  app.recommendationsEvents = new app.RecommendationsEvents();

  app.overlayView = new app.OverlayView();
  // Затемнение фона
  app.fader = new app.FaderView();

  app.mainWindow = new app.MainWindow();

  /**
   * Инициализация валют
   */
  app.currencies = new app.Currencies(app.jsonCurrencies);
  app.currencies.setCurrent(app.currentCurrency.name);

  var pageWithoutHeader
      = [
      'managerGrade',
      'unsubscribe',
      'unsubscribeTrigger',
      'lessonPage',
      'catalogRequest',
      'orderFeedback',
      'drawing-competition',
    ],
    pageWithoutFooterContacts
      = [
      'contactGroup',
    ],
    recommendItemBlock = $('.recommended-items'),
    recommendItemBlockSimilar = $('.recommended-items-similar'),
    recoUserOptions = {
      model: {
        uid: app.helpers.CookieHelper.getCookie('oko-uid'),
      },
      view: {
        algo: 'sima_rs_test_1',
        withDisinterestBtn: app.helpers.CookieHelper.getCookie('with_disinterest_btn'),
      },
    },
    searchBarOptions = {
      el: $('#search-form').length ? $('#search-form') : $('#w0'),
      user: app.user,
    },
    bodyOptions = {
      jsView: jsView,
      settlement: app.settlement,
      user: app.user,
      faderView: app.fader,
      cart: app.cart,
    },
    globalItemsCollection = null;

  app.isIE11 = new RegExp(/Trident.*rv[ :]*11\./).test(window.navigator.userAgent);
  app.isFirefox = new RegExp(/Firefox/).test(window.navigator.userAgent);
  app.jsCatalogType = layout.data('jscatalogtype');
  app.jsModel = layout.data('jsmodel');
  app.ready = false;
  app.settlementExt = new app.SettlementExt();
  app.notificationsView = new app.NotificationsView();
  var createNotification = app.notificationsView.createNotification.bind(app.notificationsView);
  app.registry.push(new app.UserView({
    settlement: app.settlement,
    user: app.user,
  }));
  app.registry.push(new app.ReduxDispatchesView({
    settlement: app.settlement,
    jsView: jsView,
  }));

  if (!_.includes(pageWithoutHeader, jsView)) {
    /**
     * Инициализация информеров.
     */
    app.informer = new app.Informer();
    app.informer.reset(app.jsonInformers);

    app.registry.push(
      new app.FooterView({
        cart: app.cart,
        settlement: app.settlement,
        user: app.user,
        disableContactsBlock: _.includes(pageWithoutFooterContacts, jsView),
      })
    );
  }
  app.registry.push(
    new app.ToTopView({
      mainWindow: app.mainWindow,
    }),
    new app.CommonPopupsView(),
    new app.NotAuthMessageView()
  );

  // Необходимо вырезать страницу из pathname
  var path = location.pathname.replace(/\/p\d+/, '');
  var recommendOptions = null;
  var recommendOptionsSimilar = null;
  var recoItemsTitles = app.recoItemsTitlesRus;
  if (app.locale !== app.LOCALES.ru) {
    recoItemsTitles = app.recoItemsTitlesEng;
  }
  switch (jsView) {
    case 'auth':
      app.districts = new app.Districts();
      app.authRouter = new app.AuthRouter();
      app.authView = new app.AuthView({
        settlement: app.settlement,
        districts: app.districts,
        isSignUpFormWithName: app.features.is_sign_up_form_with_name,
      });
      if ($('#soc-signup-form').length) {
        app.registry.push(
          new app.SocSignupFormView({ model: app.user })
        );
      }
      Backbone.history.start({ pushState: false, root: '/auth' });
      break;
    case 'cabinet':
    case 'cabinet-new':
      app.registry.push(
        new app.CabinetView({
          el: $('main'),
          settlement: app.settlement,
          user: app.user,
          userDataView: app.UserDataNewView,
          faderView: app.fader,
        }),
        new app.AgreementPopupView({
          el: '[data-popup-id="agreement"]',
          opener: '.link-data-processing-agreement',
        })
      );
      break;
    case 'cabinet-reviews':
      var collection = new app.ItemComments([], {
          defaults: {
            pageSize: 10,
            expand: 'user,reactions,item,item_comment_photos,photos_reply',
          },
          state: {
            firstPage: 1,
            pageSize: 10,
            order: 0,
          },
          user_id: app.user.get('id'),
          requestFilters: true,
        }),
        router = new app.Router({
          type: jsView,
          allowed: ['sort', 'f'],
          collection: collection,
          currencies: app.currencies,
          currency: app.currentCurrency,
        });
      app.registry.push(
        new app.CabinetReviewsView({
          user: app.user,
          router: router,
          collection: collection,
          settlement: app.settlement,
          mainWindow: app.mainWindow,
          PaginationView: app.CabinetReviewsPaginationView,
        })
      );
      Backbone.history.start({ pushState: true, root: path });
      break;
    case 'cart':
      app.cart.expand += ',groups';
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      app.cartRouter = new app.CartRouter({
        type: jsView,
        collection: app.cart,
        currency: app.currentCurrency,
        currencies: app.currencies,
      });
      app.registry.push(
        new app.ServiceOrderPopupView(),
        new app.CurrencySelectListView({
          el: '.sl-currencies-popup ul',
          router: app.cartRouter,
          model: app.currencies,
        }),
        new app.CurrencySelectStateView({
          el: '.sl-currencies-opener',
        })
      );
      app.cartCommonView = new app.CartCommonView({
        router: app.cartRouter,
        model: app.cart,
        settlement: app.settlement,
        user: app.user,
        mainWindow: app.mainWindow,
        hasGiftsForActions: app.features.is_gifts_for_action,
        currency: app.currentCurrency,
        fader: app.fader,
      });
      globalItemsCollection = app.cart;
      Backbone.history.start({ pushState: true, root: path });
      recommendOptions = recoUserOptions;
      recommendOptions.view.isCart = true;
      break;
    case 'art-uzor':
      app.registry.push(
        new app.ArtUzorView()
      );
      break;
    case 'category':
      recommendOptions = {
        model: {
          category_id: $('.recommended-items').data('category-id'),
        },
        view: {
          algo: app.features.is_loco_as_recommendations ? 'sima_recommend' : 'sima_rs_test_2',
          title: recoItemsTitles.popularInCategory,
        },
        appView: app.PersonalRecommendationsCategoryView
      };
      app.registry.push(
        new app.ServiceOrderPopupView(),
        new app.CssCarouselView({
          el: '#even-bigger-chponki-category',
          eventBus: app.EventBus,
        }),
        new app.OwlCarouselView({
          eventBus: app.EventBus,
        }),
        new app.CategoryCountdownView({
          jsModel: app.jsModel,
        })
      );
      if (app.locale === app.LOCALES.ru) {
        app.registry.push(
          new app.SeoTextView()
        );
      }
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      if (_.includes(['without-items', 'new-license', 'category-sport-nutrition'], app.jsModel)) {
        app.registry.push(
          new app.CategoryWithoutItemsView()
        );
      }
      if (app.jsModel === 'category-sport-nutrition') {
        app.registry.push(
          new app.CategorySportNutrition()
        );
      }
      if (_.includes(location.search, 'sima_stat')) {
        app.registry.push(
          new app.Filters.FiltersView({
            settlement: app.settlement,
          }),
          new app.CatalogView()
        );
        break;
      }
      /*
       * Отключаем каталог на REST для категорий с большими картинками подкатегорий и без каталога,
       * например: "Посуда", "Цифровая электроника"
       */
      if (_.includes(['big-images-category', 'without-items', 'new-license', 'category-sport-nutrition'], app.jsModel)) {
        if ($('.part-catalog').length) {
          app.registry.push(
            new app.PartSelectionView({
              user: app.user,
            })
          );
        }
        var topFilterPagesWrapper = $('.top-filter-pages .filter-pages-wrapper'),
          bottomFilterPagesWrapper = $('.bottom-filter-pages .filter-pages-wrapper'),
          groupFilterPages = $('.group-filter-pages .filter-pages-wrapper');
        if (groupFilterPages.length) {
          app.registry.push(
            new app.CategoryFilterPagesView({
              el: groupFilterPages,
              heightSubfilterPages: 160,
              isGroupFilterPages: true,
              mainWindow: app.mainWindow,
            })
          );
        }
        if (topFilterPagesWrapper.length) {
          app.registry.push(
            new app.CategoryFilterPagesView({
              el: topFilterPagesWrapper,
              mainWindow: app.mainWindow,
            })
          );
        }
        if (bottomFilterPagesWrapper.length) {
          app.registry.push(
            new app.CategoryFilterPagesView({
              el: bottomFilterPagesWrapper,
              heightSubfilterPages: 160,
              isMoreButtonInline: false,
              mainWindow: app.mainWindow,
            })
          );
        }
        app.registry.push(
          new app.CatalogView(),
          new app.CategoryBannerCarouselView({
            onInitialize: function () {
              app.registry.push(
                new app.ChponkCommonView({
                  mainWindow: app.mainWindow,
                  eventBus: app.EventBus,
                })
              );
            },
            eventBus: app.EventBus,
          })
        );
        break;
      }
      app.category = globalItemsCollection = new app.Category([], {
        isDynamicFilterPagesOff: app.features && app.features.is_dynamic_filter_pages_off,
        defaults: {
          // Подмена дефолтного значения фильтра для подфильтровой страницы
          f: app.filterUrlParam && _.isObject(app.filterUrlParam) ? JSON.stringify(app.filterUrlParam) : 'null',
          sort: $('[data-sort]').data('sort') || 'price',
          viewtype: $('[data-viewtype]').data('viewtype') || 'list',
        },
        state: {
          pageSize: Number($('[data-page-size]').data('page-size')) || 20,
        },
      });
      app.isOnRest = true;
      var allowedParams = app.Router.prototype.allowed.slice(0);
      if (app.jsModel === 'tires-and-wheels') {
        allowedParams.push('category');
      }
      app.categoryRouter = new app.Router({
        type: jsView,
        allowed: allowedParams,
        collection: app.category,
        currencies: app.currencies,
        currency: app.currentCurrency,
        allowedCookieParams: ['per-page', 'sort', 'viewtype'],
      });
      app.registry.push(
        new app.CurrencySelectListView({
          el: '.sl-currencies-popup ul',
          router: app.categoryRouter,
          model: app.currencies,
        }),
        new app.CurrencySelectStateView({
          el: '.sl-currencies-opener',
        })
      );
      var viewParams = {
        model: app.category,
        router: app.categoryRouter,
        el: '[data-jsview="category"] .reducer',
        cart: app.cart,
        mainWindow: app.mainWindow,
        currencies: app.currencies,
        currency: app.currentCurrency,
        settlement: app.settlement,
        user: app.user,
        jsView: jsView,
        jsModel: app.jsModel,
        fader: app.fader,
        isRootFilterPage: app.jsCatalogType === 'filterPage',
      };
      if (app.jsCatalogType === 'novelty') {
        viewParams.sortTemplateId = '#main-sort-filter';
      }
      if (app.jsCatalogType === 'selection') {
        viewParams.el = '[data-jsview="category"] .reducer:not(.reducer_col)';
      }
      if (app.jsCatalogType === 'trademark' && app.jsModel === 'darite-schastie') {
        app.registry.push(
          new app.DariteSchastieView()
        );
      }
      if (app.jsCatalogType === 'trademark' && app.jsModel === 'tundra') {
        app.registry.push(
          new app.TundraView()
        );
      }
      if (app.jsCatalogType === 'trademark' && app.jsModel === 'las-igras') {
        app.registry.push(
          new app.LasIgrasView({
            settlement: app.settlement,
          })
        );
      }
      if (app.jsCatalogType === 'gifts') {
        app.registry.push(
          new app.TabsCatalogItemView({ el: '.gift-item-view' })
        );
      }
      if (app.jsCatalogType === 'volume-discount-granting') {
        app.registry.push(
          new app.TabsListView({ model: app.category })
        );
      }
      app.categoryCommonView = new app.CategoryCommonView(viewParams);
      if (Backbone.history.location.hash.length > 0) {
        Backbone.history.location.hash = '';
      }
      Backbone.history.start({ pushState: true, root: path });
      if ($('.promo_top_image area').length) {
        app.registry.push(
          new app.CategoryPromoTopImageView()
        );
      }
      app.registry.push(
        new app.CategoryBannerNotnewsView()
      );
      if (!!(window.performance && typeof performance.setResourceTimingBufferSize == 'function')) {
        performance.setResourceTimingBufferSize(1000);
      }
      break;
    case 'claims':
      var claims = new app.Claims();
      var claimRouter = new app.Router({
        type: jsView,
        allowed: ['page'],
        collection: claims,
        currencies: app.currencies,
        currency: app.currentCurrency,
      });
      app.router = claimRouter;
      app.registry.push(
        new app.ClaimsCommonView({
          model: claims,
          router: claimRouter,
        })
      );
      Backbone.history.start({ pushState: true, root: path });
      break;
    case 'claim-items':
      app.claimItems = new app.ClaimItems();
      app.registry.push(
        new app.NewClaimItemsCommonView({
          model: app.claimItems,
          mainWindow: app.mainWindow,
        })
      );
      break;
    case 'collorista':
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      app.trademarkView = new app.ColloristaView();
      break;
    case 'komandor':
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      app.trademarkView = new app.KomandorView();
      break;
    case 'luazon_lighting':
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      app.trademarkView = new app.EtelView({ el: '[data-jsview = "luazon_lighting"]' });
      break;
    case 'luazon':
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      app.trademarkView = new app.EtelView({ el: '[data-jsview = "luazon"]' });
      break;
    case 'torso':
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      app.trademarkView = new app.EtelView({ el: '[data-jsview = "torso"]' });
      break;
    case 'delivery':
        app.settlement.attachOnSyncHandler();
      app.registry.push(new app.InfoDeliveryPageView({
        el: 'main.cf.limit',
        settlement: app.settlement,
        user: app.user,
        currency: app.currentCurrency,
      }));
      break;
    case 'react-delivery':
      app.settlement.expand += ',latitude,longitude';
      break;
    case 'etel':
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      app.trademarkView = new app.EtelView();
      break;
    case 'gift':
      app.registry.push(
        new app.Filters.FiltersView({
          settlement: app.settlement,
        }),
        new app.CatalogView(),
        new app.TabsListView()
      );
      if (app.locale === app.LOCALES.ru) {
        app.registry.push(
          new app.SeoTextView()
        );
      }
      break;
    case 'giftsPage':
      app.registry.push(
        new app.GiftsPageView()
      );
      break;
    case 'infoShop':
      app.registry.push(
        new app.CallMeView({
          checkAgreement: true,
          settlement: app.settlement,
        }),
        new app.AgreementPopupView({
          el: '.data-processing-agreement-popup',
          opener: '.link-data-processing-agreement',
        })
      );
      break;
    case 'infoShopIntegration':
      app.registry.push(
        new app.MessageToManagerFormView(),
        new app.MessageToCallMeFormContactGroupView({
          checkAgreement: true,
        }),
        new app.AgreementPopupView({
          el: '[data-popup-id="agreement"]',
          opener: '.link-data-processing-agreement',
        })
      );
      break;
    case 'joint-purchase':
      app.jointPurchase = new app.JointPurchaseOrganizerFormView({
        model: new app.JointPurchaseOrganizer(),
      });
      break;
    case 'joint-purchase-request':
      if (app.reduxStore) {
        if (!app.user.get('id')) {
          app.user.set('settlement_id', app.settlement.get('settlement_id'));
        }
      }
      break;
    case 'managerGrade':
      app.registry.push(
        new app.ManagerGradeFormView()
      );
      break;
    case 'news':
      app.isOnRest = true;
      app.news = new app.News();
      app.newsRouter = new app.NewsRouter({
        type: jsView,
        allowed: ['category'],
        collection: app.news,
        currencies: app.currencies,
        currency: app.currentCurrency,
      });
      app.newsView = new app.NewsView({
        model: app.news,
        router: app.newsRouter,
        currency: app.currentCurrency,
        scrollHolderClass: '.news-wrapper',
      });

      Backbone.history.start({ pushState: true, root: path });
      break;
    case 'orderHistory':
      app.registry.push(
        new app.TabsListView(),
        new app.OrderListView({
          faderView: app.fader,
        }),
        new app.ServiceOrderPopupView()
      );
      break;
    case 'order':
      var modelJson = app.helpers.TemplateHelper.getJson('#order-json');
      app.registry.push(
        new app.OrderView({
          el: '.reducer',
          model: new app.Order(modelJson),
          faderView: app.fader,
        })
      );
      break;
    case 'done':
      app.registry.push(
        new app.ServiceOrderPopupView(),
        new app.OrderDoneView()
      );
      break;
    case 'oplata' :
      app.registry.push(
        new app.TabsDeliverySearchCityView({ el: '.tabs_payment-info-page' })
      );
      break;
    case 'offer':
      app.registry.push(
        new app.CssCarouselView({
          el: '#even-bigger-chponki-category',
          eventBus: app.EventBus,
        }),
        new app.OwlCarouselView({
          eventBus: app.EventBus,
        }),
        new app.OffersListView()
      );
      break;
    case 'paymentPrepare':
      app.registry.push(
        new app.PaymentPrepareView({ el: '.reducer' })
      );
      break;
    case 'reset-password':
      app.registry.push(
        new app.PasswordResetFormView()
      );
      break;
    case 'search':
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      app.registry.push(
        new app.ServiceOrderPopupView()
      );
      if (app.locale === app.LOCALES.ru) {
        app.registry.push(
          new app.SeoTextView()
        );
      }
      if (location.search.indexOf('sima_stat') !== -1) {
        app.registry.push(
          new app.Filters.FiltersView({
            settlement: app.settlement,
            withEmptyFilter: app.features.is_search_category,
          }),
          new app.CatalogView()
        );
        break;
      }
      app.search = globalItemsCollection = new app.Search([], {
        suggest: new app.Model(),
        isShowOneItemInSearch: app.features && app.features.is_show_one_item_in_search,
      });
      app.isOnRest = true;

      app.searchRouter = new app.Router({
        type: jsView,
        allowed: ['sort', 'f', 'correct', 'q', 'qc', 'currency', 'viewtype', 'per-page', 'mode'],
        collection: app.search,
        currencies: app.currencies,
        currency: app.currentCurrency,
        allowedCookieParams: ['per-page', 'viewtype'],
      });
      app.registry.push(
        new app.CurrencySelectListView({
          el: '.sl-currencies-popup ul',
          router: app.searchRouter,
          model: app.currencies,
        }),
        new app.CurrencySelectStateView({
          el: '.sl-currencies-opener',
        })
      );
      _.merge(searchBarOptions, {router: app.searchRouter, collection: app.search});

      app.registry.push(
        new app.SuggestView({
          el: '.search-results__mistake',
          templateId: '#search-results-mistake',
          model: app.search.suggest,
          collection: app.search,
        })
      );
      app.categoryCommonView = new app.CategoryCommonView({
        model: app.search,
        router: app.searchRouter,
        sortTemplateId: '#main-sort-filter',
        el: '[data-jsview="search"] .l-main',
        cart: app.cart,
        mainWindow: app.mainWindow,
        settlement: app.settlement,
        user: app.user,
        jsView: jsView,
        jsModel: app.jsModel,
        currency: app.currentCurrency,
        withEmptyFilter: app.features.is_search_category,
        withNews: app.features.is_news_in_search,
      });
      app.similarQueriesView = new app.SimilarQueriesView({
        model: app.search,
      });
      Backbone.history.start({ pushState: true, root: path, hashChange: false });
      var $searchReviewHolder = $('.js-search-review-holder');
      if ($searchReviewHolder.length) {
        app.registry.push(
          new app.SearchReviewView({
            el: $searchReviewHolder,
            searchCollection: app.search,
            model: new app.SearchReview(),
            createNotification: createNotification,
          })
        );
      }
      recommendOptions = {
        model: {
          type: app.CACHE_TYPE_IN_SEARCH,
          uid: app.helpers.CookieHelper.getCookie('oko-uid'),
        },
        view: {
          algo: 'sima_rs_test_5',
          search: app.search,
          noInitialFetch: true,
          withDisinterestBtn: app.helpers.CookieHelper.getCookie('with_disinterest_btn'),
        },
        appView: app.PersonalRecommendationsSearchView,
      };
      cqcExecuteCommandTypes.push(app.CQC_COMMAND_TYPES.searchQueryUpdate);
      break;
    case 'sovmestnye-pokupki-service':
    case 'sovmestnye-pokupki-sp':
      case 'sovmestnye-pokupki-about':
      app.registry.push(
        new app.MessageToManagerFormView(),
        new app.MessageToCallMeFormContactGroupView({
          checkAgreement: true,
        }),
        new app.AgreementPopupView({
          el: '[data-popup-id="agreement"]',
          opener: '.link-data-processing-agreement',
        }),
        new app.JPInfoView({
          currency: app.currentCurrency,
          settlement: app.settlement,
        })
      );
      break;
    case 'spPage':
      app.registry.push(
        new app.SpView(),
        new app.CallMeView({
          el: '#first-callme-form',
          checkAgreement: true,
          settlement: app.settlement,
        }),
        new app.CallMeView({
          el: '#second-callme-form',
          checkAgreement: true,
          settlement: app.settlement,
        }),
        new app.CallMeView({
          el: '#ok-callme-form',
          checkAgreement: true,
          settlement: app.settlement,
        }),
        new app.AgreementPopupView({
          el: '.data-processing-agreement-popup',
          opener: '.link-data-processing-agreement',
        })
      );
      break;
    case 'category-form':
      app.registry.push(
        new app.CallMeView({
          el: '#category-callme-form',
          checkAgreement: true,
          settlement: app.settlement,
        }),
        new app.AgreementPopupView({
          el: '.data-processing-agreement-popup',
          opener: '.link-data-processing-agreement',
        })
      );
      break;
    case 'unsubscribe':
      app.registry.push(
        new app.UnsubscribeView(),
        new app.UnsubscribeMessageView({ type: 'is_subscribed_for_newsletter' })
      );
      recommendOptions = {
        model: {
          uid: app.helpers.CookieHelper.getCookie('oko-uid'),
        },
        view: {
          algo: 'sima_rs_test_1',
          itemsLimit: 6,
          title: '',
        },
      };
      break;
    case 'unsubscribeWaitingList':
      app.registry.push(
        new app.UnsubscribeView(),
        new app.UnsubscribeMessageView({ type: 'is_subscribed_for_waiting_list' })
      );
      recommendOptions = {
        model: {
          uid: app.helpers.CookieHelper.getCookie('oko-uid'),
        },
        view: {
          algo: 'sima_rs_test_1',
          itemsLimit: 6,
          title: '',
        },
      };
      break;
    case 'unsubscribeTrigger':
      app.registry.push(
        new app.UnsubscribeView(),
        new app.UnsubscribeMessageView({ type: 'is_subscribed_trigger' })
      );
      break;
    case 'wish':
      _.merge(bodyOptions, { autoRewritePageLinks: false });
      if (location.search.indexOf('sima_stat') !== -1) {
        app.registry.push(
          new app.Filters.FiltersView({
            settlement: app.settlement,
          }),
          new app.CatalogView()
        );
        break;
      }
      app.wishItems = globalItemsCollection = new app.WishItems([], {});
      app.isOnRest = true;
      app.wishRouter = new app.Router({
        type: jsView,
        allowed: ['sort', 'per-page', 'f', 'mode', 'viewtype', 'currency'],
        collection: app.wishItems,
        currencies: app.currencies,
        currency: app.currentCurrency,
      });
      app.registry.push(
        new app.ServiceOrderPopupView(),
        new app.CurrencySelectListView({
          el: '.sl-currencies-popup ul',
          router: app.wishRouter,
          model: app.currencies,
        }),
        new app.CurrencySelectStateView({
          el: '.sl-currencies-opener',
        })
      );
      app.categoryCommonView = new app.CategoryCommonView({
        wish: app.wish,
        model: app.wishItems,
        router: app.wishRouter,
        sortTemplateId: '#main-sort-filter',
        el: '[data-jsview="wish"] .reducer',
        cart: app.cart,
        mainWindow: app.mainWindow,
        settlement: app.settlement,
        user: app.user,
        jsView: jsView,
        currency: app.currentCurrency,
        createNotification: createNotification,
      });
      if (Backbone.history.location.hash.length > 0) {
        Backbone.history.location.hash = '';
      }
      Backbone.history.start({ pushState: true, root: path });
      break;
    case 'joint-purchase-organizer':
      app.registry.push(
        new app.JointPurchaseOrganizerPageView({
          user: app.user,
        })
      );
      break;
    case 'partAnalog':
      app.registry.push(
        new app.PartAnalogView({
          user: app.user,
          cart: app.cart,
          settlement: app.settlement,
          mainWindow: app.mainWindow,
        })
      );
      Backbone.history.start({ pushState: true, root: path });
      break;
    case 'sotsialjnaya-otvetstvennostj':
      $('img[data-imgbox-on]').each(function () {
        app.registry.push(new app.ImageView({ el: $(this) }));
      });
      break;
    case 'offers-category':
      app.registry.push(
        new app.CssCarouselView({
          el: '#even-bigger-chponki-category',
          eventBus: app.EventBus,
        }),
        new app.OwlCarouselView({
          eventBus: app.EventBus,
        }),
        new app.OffersListView(),
        new app.GiftsPageView(),
        new app.CategoryCountdownView({
          jsModel: app.jsModel,
        })
      );
      break;
    case 'trademark-design':
      app.registry.push(
        new app.CssCarouselView({
          el: '#even-bigger-chponki-category',
          eventBus: app.EventBus,
        }),
        new app.OwlCarouselView({
          eventBus: app.EventBus,
        })
      );
      break;
    case 'trademark-category':
      app.registry.push(
        new app.SeoTextView()
      );
      break;
    case 'trademark':
      $('img.lazyload').lazyload();
      break;
    case 'category-upakovka':
      app.registry.push(
        new app.CssCarouselView({
          el: '#even-bigger-chponki-category',
          eventBus: app.EventBus,
        }),
        new app.OwlCarouselView({
          eventBus: app.EventBus,
        }),
        new app.CategoryUpakovkaView({
          faderView: app.fader,
          popupElement: $('.upakovka-popup'),
          mainWindow: app.mainWindow,
        })
      );
      break;
  }
  if ($('.page404').length > 0 || jsView === 'orderView') {
    recommendOptions = recoUserOptions;
  }
  if (jsView === 'successfulSubscription') {
    recommendOptions = {
      model: {
        uid: app.helpers.CookieHelper.getCookie('oko-uid'),
      },
      view: {
        algo: 'sima_rs_test_1',
        withDisinterestBtn: app.helpers.CookieHelper.getCookie('with_disinterest_btn'),
        title: 'Интересные предложения для вас',
      },
    };
  }

  app.searchBar = new app.SearchBarView(searchBarOptions);

  // инициализация модели и вью наших рекоммендаций
  function _initRecommendationBlock (options) {
    app.personalRecommendations = new app.PersonalRecommendations(
      null,
      {
        isLocoItems: jsView === 'category' && app.features.is_loco_as_recommendations,
        requestParameters: options && options.model ? options.model : null,
      }
    );
    options.view.model = app.personalRecommendations;
    options.view.cart = app.cart;
    options.view.mainWindow = app.mainWindow;
    options.view.user = app.user;
    options.view.settlement = app.settlement;
    var prView = app.PersonalRecommendationsView;
    if (options.appView) {
      prView = options.appView;
    }
    app.registry.push(
      new prView(options.view)
    );
  }

  app.bodyView = new app.BodyView(bodyOptions);

  // Блок рекомендаций "С этим товаром покупают"
  if (recommendItemBlock.length && recommendOptions) {
    _initRecommendationBlock(recommendOptions);
  }
  // Блок рекомендаций "Похожие товары"
  if (recommendItemBlockSimilar.length && recommendOptionsSimilar) {
    _initRecommendationBlock(recommendOptionsSimilar);
  }

  // данные для `ecommerce`.
  app.EcEvents = new app.EcommerceEvents();
  // данные для `Oko`.
  app.okoEvents = new app.OkoEvents(_.merge({
    wish: app.wish,
    search: app.search,
    category: app.category,
    categoryRouter: app.categoryRouter,
    searchRouter: app.searchRouter,
  }, jsView === 'wish' && {
    wishItems: app.wishItems,
    wishRouter: app.wishRouter,
  }));
  if (app.hasVkTargeting) {
    app.vkEvents = new app.VkEvents({}, {
      wish: app.wish,
      collection: globalItemsCollection,
      cart: app.cart,
      currency: app.currentCurrency,
      jsView: jsView,
      recommendationModel: app.personalRecommendations,
    });
  }
  /**
   *  Если есть смартбаннер, не показываем обычный баннер
   */
  if ($('.smartbanner').length) {
    $('.b-home-chponck').hide();
    $('.wait-sec-pls').addClass('not_display');
  } else {
    // следим за баннерами
    var hasChponkCommonView = app.registry
      .filter(function(el) {
        return el instanceof app.ChponkCommonView;
      })
      .length > 0;
    if (!hasChponkCommonView)  {
      app.registry.push(
        new app.ChponkCommonView({
          mainWindow: app.mainWindow,
          eventBus: app.EventBus,
        })
      );
    }
  }

  /**
   * Попап для старых браузеров и попап с сообщением об удаленном подарке.
   */
  app.registry.push(
    new app.OldBrowserPopupView({
      versions: app.helpers.BrowserDetectHelper.getCurrentOsVersions(),
      bowser: window.bowser,
      operaMiniOrMobileOptions: app.helpers.BrowserDetectHelper.getOperaMiniOrMobileOptions(),
      isPageSpeedTest: navigator.userAgent.indexOf('Google Page Speed') !== -1,
    }),
    new app.DeletedGiftPopupView({
      fader: app.fader,
    })
  );

  // Отслеживание кастомных событий ОКО
  var okoWatcherData = app.GET_STATIC_CUSTOM_EVENTS_DATA(true);
  if (okoWatcherData.length) {
    app.registry.push(
      new app.OkoWatcher({
        el: 'body',
        okoWatcherObjects: okoWatcherData,
      })
    );
  }

  if (
    ['reactive-checkout'].indexOf(jsView) !== -1
    || path.search(/\/parts\//) !== -1
  ) {
    var okoWatcher;
    app.registry.push(
      okoWatcher = new app.OkoWatcher({
        el: 'body',
        okoWatcherObjects: [],
      })
    );
    app.INIT_DYNAMIC_CUSTOM_EVENTS_UPDATE(okoWatcher, true);
  }

  cqcExecuteCommandTypes.push(app.CQC_COMMAND_TYPES.settlementUpdate);
  cqcExecuteCommandTypes.push(app.CQC_COMMAND_TYPES.districtUpdate);

  var isJsViewWithoutReload = [
    'cart',
    'category',
    'search',
    'wish',
  ].indexOf(jsView) > -1;
  var isCategoryJsModelWithReload = [
      'big-images-category',
      'without-items',
      'category-sport-nutrition',
      'new-license',
    ].indexOf(app.jsModel) > -1;
  if (isJsViewWithoutReload && !isCategoryJsModelWithReload) {
    cqcExecuteCommandTypes.push(app.CQC_COMMAND_TYPES.currencyUpdate);
  } else {
    // для страниц где нужна перезагрузка страницы при смене валюты
    var currencyUpdateCallback = function (data) {
      var newCurrencyName = data.currency.name;
      if (newCurrencyName !== app.currentCurrency.name) {
        app.helpers.RedirectHelper.redirectWithNewParams({ currency: newCurrencyName });
      }
    };

    app.helpers.CQCHelper.subscribeToCommand(app.CQC_COMMAND_TYPES.currencyUpdate, currencyUpdateCallback);
  }

  // отслеживание cqc команд
  if (cqcExecuteCommandTypes.length) {
    app.helpers.CQCHelper.subscribeToCommand(cqcExecuteCommandTypes);
  }

  Backbone.trigger('app-initialized');
});

}.call(window));